import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ResumeUpdaterService } from '../../cart/services/cart-resume-updater.service';
import { Router } from '@angular/router';
import { DeliveryStepsService } from '../services/delivery-steps.service';
import { PaymentService } from '../services/payment.service';
import { Response } from '@angular/http';
import { PlanModel } from '../../shared/models/plan.model';
import { CommonHttpService } from '../../shared/services/http.service';
import { AuthenticatedUserRepositoryService } from '../services/authenticated-user-repository.service';
import { Subscription } from 'rxjs/Subscription';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'payment-resume',
    templateUrl: './payment.resume.component.html',
    styleUrls: ['./../payment.component.scss']
})
export class PaymentResumeComponent implements OnInit, OnDestroy {
    public subtotal: number;
    public freight: number;
    public total: number;
    public discount: number;
    public loading = false;
    public recurrent = false;
    public recurrentAs: PlanModel;
    @Input() deliverable = false;
    @Input() items = [];
    @Input() paymentReady = false;

    resumeUpdaterServiceIndexing: Subscription;
    resumeUpdaterServiceUpdating: Subscription;
    resumeUpdaterServiceIndexed: Subscription;
    resumeUpdaterServiceUpdated: Subscription;
    deliveryStepsServiceSelectedFreight: Subscription;
    deliveryStepsServiceResetedSelectedFreight: Subscription;
    paymentServiceRefused: Subscription;
    authenticatedUserServiceChangedUser: Subscription;

    constructor(
        protected router: Router,
        protected resumeUpdaterService: ResumeUpdaterService,
        protected deliveryStepsService: DeliveryStepsService,
        protected paymentService: PaymentService,
        protected http: CommonHttpService,
        protected authenticatedUserService: AuthenticatedUserRepositoryService
    ) { }

    ngOnInit() {
        this.resumeUpdaterServiceUpdating = this.resumeUpdaterService.updating$.subscribe(() => {
            this.loading = true;
        });
        this.resumeUpdaterServiceIndexed = this.resumeUpdaterService.indexed$.subscribe((index: any) => {
            this.subtotal = index.subtotal;
            this.freight = index.freight;
            this.discount = index.discount;
            this.total = index.total;
        });
        this.resumeUpdaterServiceUpdated = this.resumeUpdaterService.updated$.subscribe(() => {
            this.loading = false;
        });
        this.deliveryStepsServiceSelectedFreight = this.deliveryStepsService.selectedFreight$.subscribe(() => {
            this.resumeUpdaterService.refresh().subscribe();
        });
        this.deliveryStepsServiceResetedSelectedFreight = this.deliveryStepsService.resetedSelectedFreight$.subscribe(() => {
            this.resumeUpdaterService.refresh().subscribe();
        });
        this.paymentServiceRefused = this.paymentService.refused$.subscribe(() => {
            this.refresh();
        });
        this.authenticatedUserServiceChangedUser = this.authenticatedUserService.changedUser$.subscribe(() => {
            this.refresh();
        });

        this.refresh();
        this.fetchProperties();
        if (this.items.length === 0) {
            this.router.navigate(
                ['/checkout/cart'],
                {
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                }
            );
        }
    }
    ngOnDestroy() {
        // Overrided by AutoUnsubscribe
    }

    private refresh() {
        this.resumeUpdaterService.refresh().subscribe();
    }
    /**
     * Fetch cart properties.
     **/
    public fetchProperties() {
        this.http
            .get('/checkout/cart/properties')
            .subscribe((response: Response) => {
                const data = response.json();
                this.recurrent = data.properties !== undefined
                    && data.properties.recurrent_as !== undefined
                    && data.properties.recurrent_as !== null;

                if (this.isRecurrent()) {
                    this.recurrentAs = data.properties.recurrent_as;
                }
            });
    }
    /**
     * This checks if cart has recurrent_as property.
     **/
    public isRecurrent() {
        return this.recurrent;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/payment/resume/payment.resume.component.ts